// ManagePayoutExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";
const ExportManagePayoutExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Payout History");
  // Translation binding
  const t = i18n.t.bind(i18n);
  // Define columns
  worksheet.columns = [
    { header: t("managePayout.id"), key: "id", width: 12 },
    { header: t("walletDetails.companyName"), key: "companyName", width: 25 },
    { header: t("walletDetails.paypalBatchId"), key: "batchId", width: 20 },
    { header: t("managePayout.payout_amount"), key: "payoutAmount", width: 18 },
    { header: t("managePayout.method"), key: "method", width: 15 },
    { header: t("managePayout.payment_date"), key: "paymentDate", width: 25 },
    { header: t("managePayout.email"), key: "email", width: 30 },
    { header: t("managePayout.status"), key: "status", width: 15 },
  ];

  // Add rows
  worksheet.addRows(
    data.map((item) => ({
      id: item.id,
      companyName: item.companyName,
      batchId: item.batchId,
      payoutAmount: item.payoutAmount,
      method: item.method,
      paymentDate: item.paymentDate,
      email: item.email,
      status: item.status || item.payoutStatus, // handle both keys
    }))
  );

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White Bold
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "003149" }, // Dark Blue
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Export as Excel
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "Manage_Payouts.xlsx");
};

export default ExportManagePayoutExcel;
